// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-login_frame_2iuFKJNe{-webkit-box-shadow:0 0 10px 0 rgba(80,90,109,.16);box-shadow:0 0 10px 0 rgba(80,90,109,.16);-webkit-transition:-webkit-box-shadow .2s;transition:-webkit-box-shadow .2s;transition:box-shadow .2s;transition:box-shadow .2s,-webkit-box-shadow .2s}", ""]);
// Exports
exports.locals = {
	"frame": "s-login_frame_2iuFKJNe"
};
module.exports = exports;
